import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _omit from 'lodash/omit';
import { Text } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { negativeMarginMixin } from '../../mixins/negativeMarginMixin.js';
import ThemeCmsConstellation from '../../themes/ThemeCmsConstellation.js';
import customPropTypes from '../../utils/custom-prop-types.js';

var _excluded = ["placement"],
  _excluded2 = ["as"];
var StyledHeading = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-l044if-0"
})(["", ""], negativeMarginMixin);
var Placements = {
  page: 'page',
  post: 'post'
};
var POST_FONT_TYPE_BY_AS = {
  h1: {
    default: 'h4',
    md: 'h3',
    xl: 'h3'
  },
  h2: {
    default: 'h5',
    md: 'h4',
    xl: 'h4'
  },
  h3: {
    default: 'h6',
    md: 'h5',
    xl: 'h5'
  },
  h4: {
    default: 'h6',
    md: 'h6',
    xl: 'h6'
  },
  h5: {
    default: 'bodySmallHeading',
    md: 'bodySmallHeading',
    xl: 'bodySmallHeading'
  },
  h6: {
    default: 'finePrintHeading',
    md: 'finePrintHeading',
    xl: 'finePrintHeading'
  }
};
var POST_MARGINS = {
  h2: {
    marginTop: 'md',
    marginBottom: 'sm'
  },
  h3: {
    marginTop: 'md',
    marginBottom: 'xs'
  },
  h4: {
    marginTop: 'sm',
    marginBottom: 'xs'
  },
  h5: {
    marginTop: 'sm',
    marginBottom: 'xxs'
  },
  h6: {
    marginTop: 'sm',
    marginBottom: 'none'
  }
};
var Heading = function Heading(_ref) {
  var placement = _ref.placement,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (placement === Placements.post) {
    return /*#__PURE__*/React.createElement(PostHeading, rest);
  }
  return /*#__PURE__*/React.createElement(StyledHeading, rest);
};
var PostHeading = function PostHeading(_ref2) {
  var as = _ref2.as,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    as: as
  }, _omit(rest, 'margin'), {
    fontType: POST_FONT_TYPE_BY_AS[as]
  }, POST_MARGINS[as]));
};
var AsPropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']) : {};
PostHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  as: AsPropType.isRequired
} : {};
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  as: AsPropType.isRequired,
  fontColor: PropTypes.oneOf(Object.keys(ThemeCmsConstellation.constellation.colors)).isRequired,
  fontFamily: PropTypes.oneOf(['serif', 'sansSerif']).isRequired,
  margin: customPropTypes.inlineMediaQuery(PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginLeft: PropTypes.string,
    marginBottom: PropTypes.string
  })),
  placement: PropTypes.oneOf(Object.keys(Placements)).isRequired,
  // Ignored if placement is `Placements.post`, so it's optional. However if
  // placement is `Placements.page`, then this is required.
  fontType: customPropTypes.inlineMediaQuery(PropTypes.string),
  textAlign: customPropTypes.inlineMediaQuery(PropTypes.oneOf(['center', 'left', 'right']))
} : {};
var Heading$1 = Heading;

export { Heading$1 as default };
